// TEK17 og Forskrift om tryggere bolighandel - Paragraftekst og forklaring
// NB: Dette er forenklede sammendrag. Se lovdata.no for fullstendig lovtekst.

export const paragrafTekst = {
  'TEK17 §11-7': {
    tittel: 'TEK17 §11-7 - Rømningsvei',
    sammendrag: `Soverom og andre rom der det er vanlig å oppholde seg skal ha rømningsvei til sikkert sted ute.

Krav til rømningsvei:
• Minst én rømningsvei (dør eller vindu)
• Vindu som rømningsvei: Min. 0,6 m² åpning, høyde/bredde min. 0,6 m
• Må være mulig å rømme ut

Vanlige avvik:
- Soverom i kjeller uten tilfredsstillende rømningsvei
- Vinduer som er for små eller ikke kan åpnes
- Gjennomgående rømningsvei blokkert`,
    konsekvens: 'Manglende rømningsvei er alvorlig sikkerhetsrisiko ved brann. Dette gir TG3 og krever umiddelbar utbedring.',
    tilstandsgrad: 'TG3 - Alvorlig avvik',
    referanse: 'Byggteknisk forskrift (TEK17) §11-7',
    lovdataUrl: 'https://lovdata.no/forskrift/2017-06-19-840/%C2%A711-7',
  },

  'TEK17 §13-2': {
    tittel: 'TEK17 §13-2 - Dagslys',
    sammendrag: `Rom der det er vanlig å oppholde seg skal ha tilfredsstillende dagslysforhold.

Minimumskrav:
• Vindu med lysåpning på minst 1/10 av gulvareal (10%)

Eksempel: Rom på 15 m² skal ha vindu på minimum 1,5 m²

Gjelder ikke:
- Hvis funksjonskravet oppfylles på annen måte (f.eks. lyssjakter)`,
    konsekvens: 'Utilstrekkelig dagslys påvirker trivsel, helse og bomiljø. Vanligvis TG2 ved mindre avvik.',
    tilstandsgrad: 'TG2-TG3 avhengig av avvikets størrelse',
    referanse: 'Byggteknisk forskrift (TEK17) §13-2',
    lovdataUrl: 'https://lovdata.no/forskrift/2017-06-19-840/%C2%A713-2',
  },

  'TEK17 §13-8': {
    tittel: 'TEK17 §13-8 - Ventilasjon',
    sammendrag: `Bygning skal ha tilfredsstillende ventilasjon for å sikre god luftkvalitet og fjerne fukt.

Minimumskrav luftmengder for boliger:
• Kjøkken: 20 m³/t tilluft + avtrekk over komfyr
• Bad/WC: 30 m³/t
• Soverom/stue: 1,2 m³/t per m² gulvareal

Kjøkken må ha:
• Avtrekk for å fjerne lukt, fukt og forurensning fra matlaging
• Vanligvis avtrekksvifte over komfyr

Vanlige avvik:
- Manglende avtrekk i kjøkken
- Ikke-funksjonell ventilasjon
- Utilstrekkelig kapasitet`,
    konsekvens: 'Manglende/utilstrekkelig ventilasjon fører til fuktproblemer, mugg, dårlig inneklima og helseplager. I kjøkken gir dette kondensering og fuktskader på overflater (vegger, tak, skap).',
    tilstandsgrad: 'TG2-TG3 avhengig av konsekvenser',
    referanse: 'Byggteknisk forskrift (TEK17) §13-8',
    lovdataUrl: 'https://lovdata.no/forskrift/2017-06-19-840/%C2%A713-8',
  },

  'TEK17 §13-9': {
    tittel: 'TEK17 §13-9 - Sikkerhet mot fuktskader i våtrom',
    sammendrag: `Våtrom skal utføres slik at fukt ikke skader bygningen.

Hovedkrav:
• Gulv skal ha fall mot sluk
• Sluk skal være tilstrekkelig dimensjonert
• Overflater skal tåle fukt og være lette å rengjøre

Tetting/membran:
• Minst 200 mm opp på vegger
• Ved dusj/badekar: Minst 1800 mm høyde
• Ubrutt membran tilpasset sluk

Høydeforskjell sluk:
• Minst 25 mm fra topp slukrist til laveste punkt i gulv
• Synlig topp membran skal ligge minst 50 mm under slukrist

Vanlige avvik:
- Manglende/defekt membran
- Utilstrekkelig fall mot sluk
- For liten høydeforskjell ved sluk
- Membran ført for lavt opp på vegg`,
    konsekvens: 'Avvik kan gi vanninntrenging i konstruksjonen med fukt- og råteskader som følge. Dette kan spre seg til tilstøtende rom og bærende konstruksjoner. Utbedring er ofte omfattende og kostbar. Gir normalt TG3.',
    tilstandsgrad: 'TG3 - Ved avvik som kan gi vannskader',
    referanse: 'Byggteknisk forskrift (TEK17) §13-9',
    lovdataUrl: 'https://lovdata.no/forskrift/2017-06-19-840/%C2%A713-9',
  },

  '§2-2': {
    tittel: 'Forskrift §2-2 - Våtrom (Forskrift til avhendingslova)',
    sammendrag: `Tilstandsrapport for våtrom skal inneholde undersøkelse av:

• Overflater (vegger, gulv, himling)
• Tetningsmembran (der tilgjengelig)
• Sluk og fall mot sluk
• Høydeforskjeller ved sluk
• Fuktindikatorer (misfarging, flekker, deformasjoner)
• Ventilasjon

Hulltaking:
Det skal foretas hulltaking i tilstøtende vegger for å avdekke fuktskader, med mindre dokumentasjon viser at våtrommet er utført riktig.`,
    konsekvens: 'Manglende undersøkelse medfører at tilstandsrapporten ikke er forskriftsmessig.',
    tilstandsgrad: 'N/A - Undersøkelsesplikt',
    referanse: 'Forskrift til avhendingslova §2-2',
    lovdataUrl: 'https://lovdata.no/forskrift/2021-06-08-1850/%C2%A72-2',
  },

  '§2-22': {
    tittel: 'Forskrift §2-22 - Resultatet av undersøkelsene',
    sammendrag: `Hvis et rom eller en bygningsdel gis tilstandsgrad 2 eller 3, skal den bygningssakkyndige redegjøre for:

a) ÅRSAKEN til tilstanden (hva har forårsaket det?)
b) KONSEKVENSEN av tilstanden (hvilke følger har/kan det få?)

Krav:
• Redegjørelsen skal være konkret og forståelig
• Skal kunne forstås av leser uten fagkunnskap
• Ved TG3: Angi hastegrad for tiltak`,
    konsekvens: 'Manglende årsaks- og konsekvensbeskrivelse gjør at rapporten ikke oppfyller lovkravet. Kjøper får ikke nødvendig informasjon til å vurdere kostnader og risiko.',
    tilstandsgrad: 'N/A - Dokumentasjonskrav ved TG2/TG3',
    referanse: 'Forskrift til avhendingslova §2-22',
    lovdataUrl: 'https://lovdata.no/forskrift/2021-06-08-1850/%C2%A72-22',
  },
};

export const hentParagrafInfo = (paragrafRef) => {
  return paragrafTekst[paragrafRef] || null;
};
